import Image from 'next/image';
import ValidationMessage from '../PcModelValidationMessage';
import styles from './styles';

const ValidationAlert = ({ errors }) => {
	console.log({errors})

	return (
		<>
			<div className="alert-box">
				{errors.map((error, index) => (
					<div className="alert-item" key={JSON.stringify(error)}>
						<div className="alert-image">
							<Image draggable={false} 
								src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-exclamation-blue.svg?v=1713944876"
								alt="Error"
								width={16}
								height={16}
							/>
						</div>
						<div className="alert-message">
							<ValidationMessage
								error={error}
								prevError={index !== 0 ? errors[index - 1] : {}}
							/>
						</div>
					</div>
				))}
			</div>

			<style jsx>{styles}</style>
		</>
	);
};

ValidationAlert.propTypes = {};

export default ValidationAlert;
